
import commonApi from "@/apis/common.api";
import gripUtil from "@/libs/grip.util";
import { $_GCD, $_DKD } from '@/confs/common.const.js';

export default {
    state: {
        openapiEndpointMap: {},
        datasrcList: [],
        datasrcCateList: [],
        datasrcCateMap: {},
        openApiTab: [
            {code: '01', name: '분야별 데이터'},
            // {code: '02', name: '오류신고'},
        ],
        selectedOpenApiTab: 'sectionData',
        openapiGridData: [],
        errorReport: [],
    },
    getters: {
        getOpenapiEndpointMap(state) {
            return state.openapiEndpointMap;
        },
        getDatasrcList(state) {
            return state.datasrcList;
        },
        getDatasrcCateList(state) {
            return state.datasrcCateList;
        },
        getDatasrcCateMap(state) {
            return state.datasrcCateMap;
        },
        getOpenApiTab(state) {
            return state.openApiTab;
        },
        getSelectedOpenApiTab(state) {
            return state.selectedOpenApiTab;
        },
        getOpenapiGridData(state) {
            return state.openapiGridData;
        },
        getErrorReport(state) {
            return state.errorReport;
        },
    },
    mutations: {
        OPENAPI_ENDPOINT_MAP(state, openapiEndpointMap) {
            state.openapiEndpointMap = openapiEndpointMap;
        },
        DATASRC_LIST(state, datasrcList) {
            state.datasrcList = datasrcList;
        },
        DATASRC_CATE_LIST(state, datasrcCateList) {
            state.datasrcCateList = datasrcCateList;
        },
        DATASRC_CATE_MAP(state, datasrcCateMap) {
            state.datasrcCateMap = datasrcCateMap;
        },
        OPEN_API_TAB(state, openApiTab) {
            state.openApiTab = openApiTab;
        },
        SELECTED_OPEN_API_TAB(state, selectedOpenApiTab) {
            state.selectedOpenApiTab = selectedOpenApiTab;
        },
        OPENAPI_GRID_DATA(state, openapiGridData) {
            state.openapiGridData = openapiGridData;
        },
        ERROR_REPORT(state, errorReport) {
            state.errorReport = errorReport;
        },
    },
    actions : {
        FETCH_OPENAPI_ENDPOINT_MAP({commit}) {
            return commonApi.fetchOpenapiEndpointList()
                .then(res=>{
                    commit('OPENAPI_ENDPOINT_MAP', gripUtil.toDict(res.data.data, 'dataKdSqno'));
                });
        },
        FETCH_DATASRC_LIST({commit}) {
            return commonApi.fetchDataSrcList()
                .then(res=>{
                    commit('DATASRC_LIST', res.data.data);
                });
        },
        FETCH_DATASRC_CATE_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($_GCD.DATASRC_CATE)
                .then(res=>{
                    commit('DATASRC_CATE_LIST', res.data.data);
                    commit('DATASRC_CATE_MAP', gripUtil.toDict(res.data.data, 'commonCode'));
                });
        },

        SET_OPEN_API_TAB({commit}, openApiTab) {
            commit('OPEN_API_TAB', openApiTab);
        },

        SET_SELECTED_OPEN_API_TAB({commit}, selectedOpenApiTab) {
            commit('SELECTED_OPEN_API_TAB', selectedOpenApiTab);
        },

        FETCH_OPENAPI_GRID_DATA({commit}) {
            return commonApi.fetchRepoDataList($_DKD.OPENAPI_GRID_DATA, '', true)
                .then(res=>{
                    let list = res.data.data;
                    list.sort((pre, cur) => {
                        return Number(pre.val1) - Number(cur.val1);
                    })
                    let newTab = this.getters.getOpenApiTab;
                    list.forEach((d, idx) => {
                        if(d.val7 == 'N') {
                            newTab.splice(idx, 1);
                        }
                    });
                    list = res.data.data.filter(d => {
                        return d.val6 == 'Y';
                    });
                    // console.log('newTab', newTab);
                    commit('OPEN_API_TAB', newTab);
                    commit('OPENAPI_GRID_DATA', list);
                });
        },

        FETCH_ERROR_REPORT({commit}) {
            return commonApi.fetchRepoDataList($_DKD.OPENAPI_ERROR_REPORT, '', true)
                .then(res => {
                    // console.log('res', res);
                    commit('ERROR_REPORT', res.data.data);
                })
        }
    }
};
